const fullValidation = (t) => ({
  password,
}) => {
  let errors = {};

  return errors;
};

export default fullValidation;
